export default "__VITE_ASSET__BstbfSCS__"